const TransactionParentType = {
    0: 'Offer',
    1: 'Transaction'
    // 2: 'ReclaimedOffer',
};

export default TransactionParentType;
